export default __webpack_public_path__ + "locales/en/FillPDFDialog.json?hash=e3a180f92a945db67d4ed60911169ccb";